import { pipe, omit } from 'ramda';
import {
  mkAnswerAsObjectForPath,
  mkResourceWithAnswerObject,
} from 'src/features/core/ChatEngine/Bot/botServiceUtils/arrayTypeUtils';

//////////////////  PUBLIC FUNCTIONS ////////////////////////

/**
 * mkMapAndComposeUpdate - this method will make a array of data by mapping same key into one object and then
 * find the index and will modify if data is alreay in api,if now it will push that array of data formed into that
 * array ,so it is used for declaration,duffle bag where two will be mapped into same object
 * @param mapFields this will have the fields that needs to be mapped in save in api
 * @param _questionId can have question id
 * @param array this will have a array
 */
export const mkAPIUpdateableForArrayType = (dataBag: any) => {
  const { filterArrayTypeData: arrayOfPath } = dataBag;
  return pipe(
    mkAnswerAsObjectForPath,
    mkResourceWithAnswerObject
  )({
    arrayOfPath,
    ...omit(['arrayOfPath'], dataBag),
  });
};

